import {CanActivateFn, Router} from '@angular/router';
import {catchError, map, of, switchMap} from 'rxjs';
import {inject} from '@angular/core';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {GetParams} from '@app/shared';
import {PartnerService} from '../services/partner.service';
import {AuthService} from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const oidcService = inject(OidcSecurityService);
  const partnerService = inject(PartnerService);
  const authService = inject(AuthService);
  const router = inject(Router);

  // Sin el usuario de Sourtrack la app queda a medias (permisos y datos indefinidos):
  // mejor avisar y ofrecer reintentar que dejar entrar.
  const authErrorUrl = router.createUrlTree(['/auth/error']);

  return oidcService.checkAuth(undefined, '0-sourtrack_web').pipe(
    switchMap(({ isAuthenticated }) => {
      if (!isAuthenticated) {
        oidcService.authorize();
        return of(false);
      }

      return oidcService.getUserData().pipe(
        switchMap(userData => {
          const params: GetParams = {
            startRow: 0,
            endRow: 1,
            sortProperty: 'id',
            sortDirection: 'asc',
            filterProperty: 'email',
            filterValue: userData.email
          };

          return partnerService.getUser(params).pipe(
            map(rsp => {
              // El backend omite `rows` cuando no encuentra al usuario por email.
              const user = rsp?.data?.rows?.[0];
              authService.loggedUser = user;
              return user ? true : authErrorUrl;
            }),
            catchError(error => {
              console.error(error);
              authService.loggedUser = undefined;
              return of(authErrorUrl);
            })
          );
        })
      );
    })
  );
};

